const joinSegments = (...segments: string[]): string =>
  '/' +
  segments
    .flatMap((s) => s.split('/'))
    .filter(Boolean)
    .join('/');

export const createURLPath = (...basePath: string[]) => {
  return (...path: string[]) => {
    return joinSegments(...basePath, ...path);
  };
};
